export default "__VITE_ASSET__BJZqLxdm__"